// extracted by mini-css-extract-plugin
export var mergingIntoPill = "_lg-1";
export var rowFirst = "_lg-3";
export var rowLast = "_lg-5";
export var rowMiddle = "_lg-4";
export var ticketListScroll = "_lg-2";
export var ticketStack = "_lg-0";